import { render, staticRenderFns } from "./MallResult.vue?vue&type=template&id=5a65da84&scoped=true&"
import script from "./MallResult.vue?vue&type=script&lang=ts&"
export * from "./MallResult.vue?vue&type=script&lang=ts&"
import style0 from "./MallResult.vue?vue&type=style&index=0&id=5a65da84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65da84",
  null
  
)

export default component.exports